"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TraceTagsToggler = void 0;

var _react = _interopRequireWildcard(require("react"));

var _molecules = require("../../../molecules");

var _atoms = require("../../../atoms");

require("./TraceTagsToggler.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Trace Tags Toggler
var TraceTagsToggler = function TraceTagsToggler(_ref) {
  var sportType = _ref.sportType,
      tags = _ref.tags,
      onTag = _ref.onTag;

  var _useState = (0, _react.useState)(sportType === "baseball" ? "Pitching" : "Attacking"),
      _useState2 = _slicedToArray(_useState, 2),
      category = _useState2[0],
      setCategory = _useState2[1];

  return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "TagsToggler"
  }, sportType === "baseball" && /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    className: "button-group"
  }, /*#__PURE__*/_react.default.createElement(_molecules.Button, {
    primary: category === "Pitching",
    content: "Pitching",
    onClick: function onClick(e) {
      return setCategory("Pitching");
    },
    trkAction: "Pitching Tab Pressed",
    small: true
  }), /*#__PURE__*/_react.default.createElement(_molecules.Button, {
    primary: category === "Hitting",
    content: "Hitting",
    onClick: function onClick(e) {
      return setCategory("Hitting");
    },
    trkAction: "Hitting Tab Pressed",
    small: true
  }), /*#__PURE__*/_react.default.createElement(_molecules.Button, {
    primary: category === "Fielding",
    content: "Fielding",
    onClick: function onClick(e) {
      return setCategory("Fielding");
    },
    trkAction: "Fielding Tab Pressed",
    small: true
  })), sportType === "soccer" && /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    className: "button-group"
  }, /*#__PURE__*/_react.default.createElement(_molecules.Button, {
    primary: category === "Attacking",
    content: "Attack",
    onClick: function onClick(e) {
      return setCategory("Attacking");
    },
    trkAction: "Attacking Tab Pressed",
    small: true
  }), /*#__PURE__*/_react.default.createElement(_molecules.Button, {
    primary: category === "Defense",
    content: "Defense",
    onClick: function onClick(e) {
      return setCategory("Defense");
    },
    trkAction: "Defensive Tab Pressed",
    small: true
  }), /*#__PURE__*/_react.default.createElement(_molecules.Button, {
    primary: category === "Goalkeeping",
    content: "GK",
    onClick: function onClick(e) {
      return setCategory("Goalkeeping");
    },
    trkAction: "Goalkeeper Tab Pressed",
    small: true
  })), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "tags"
  }, tags.map(function (tag) {
    if (tag.category === category) {
      return /*#__PURE__*/_react.default.createElement(_molecules.Chip, {
        key: "".concat(category, "-").concat(tag.name),
        content: tag.editor && tag.editor.title ? tag.editor.title : tag.title,
        background: tag.selected ? "black-color" : "grey4-color",
        color: tag.selected ? "white2-color" : "black-color",
        margin: "1",
        fat: 1,
        id: tag.name,
        onClick: function onClick(e) {
          console.log("Clicked tag", e, tag);
          onTag(tag.name);
        }
      });
    } else {
      return null;
    }
  })));
};

exports.TraceTagsToggler = TraceTagsToggler;
TraceTagsToggler.defaultProps = {
  tags: [],
  onTag: function onTag() {}
};